import AUploadField from './index.vue';

AUploadField.install = app => {
  app.component(AUploadField.name, AUploadField);
};

export default AUploadField;
